var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 19.6992V10.5217C21 9.94286 20.7492 9.39238 20.3124 9.01253L12.8124 2.49079C12.0598 1.8364 10.9402 1.8364 10.1876 2.49079L2.68764 9.01253C2.25082 9.39238 2 9.94286 2 10.5217V19.6992C2 20.8038 2.89543 21.6992 4 21.6992H19C20.1046 21.6992 21 20.8038 21 19.6992ZM1.37529 7.50332C0.501634 8.26301 0 9.36398 0 10.5217V19.6992C0 21.9084 1.79086 23.6992 4 23.6992H19C21.2091 23.6992 23 21.9084 23 19.6992V10.5217C23 9.36398 22.4984 8.26301 21.6247 7.50332L14.1247 0.981578C12.6196 -0.327193 10.3804 -0.327192 8.87528 0.981578L1.37529 7.50332Z",
    fill: "#102D3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParents);
export default __webpack_public_path__ + "static/media/Parents.d7eb65a5683ad7da88873902744b9299.svg";
export { ForwardRef as ReactComponent };